import React, { useState } from "react";
import * as R from "ramda";
import { FormattedMessage, useIntl } from "react-intl";
import { VStack, Box, Button } from "@chakra-ui/react";

import { inIframe, FLOW_STATE, useSessionCtx } from "utils";
import { Page } from "components/Page";
import Header from "flows/components/Header";
import ContentContainer, { centeringBox } from "components/Container";
import { AddPaypalButton } from "components/Paypal";
import { CreditCard } from "./CreditCard";
import { usePaypalResponseHandler } from "./usePaypalResponseHandler";

const IFrame = (props) => {
  return (
    <ContentContainer id="framemax">
      <div {...props} />
    </ContentContainer>
  );
};

const FullPage = (props) => {
  return (
    <Page>
      <div style={centeringBox} {...props}></div>
    </Page>
  );
};

const AddCCButton = ({ onClick }) => {
  return (
    <Button
      data-testid="pm-add-cc-button"
      width="full"
      variant="outline"
      colorScheme="gray"
      onClick={onClick}
    >
      <FormattedMessage defaultMessage="Add Credit Card" description="button label" />
    </Button>
  );
};

export const Buttons = ({ config, onComplete, ...props }) => {
  const { formatMessage } = useIntl();
  const { debug } = useSessionCtx();
  debug("buttons__config: ", config);

  const [ccState, setCCState] = useState(false);
  const handleCCClick = () => setCCState(true);

  // intercept complete and stay here on cancel
  const handleCCComplete = (payload) => {
    if (R.propEq("state", FLOW_STATE.CANCEL, payload)) {
      setCCState(false);
    } else {
      onComplete(payload);
    }
  };

  const handleCancel = () => {
    onComplete({ state: "cancel" });
  };

  usePaypalResponseHandler((payload) => {
    debug("ADDPM__BUTTONS_PAYPALRESPONSE", payload);
    // stay on this screen if the user canceled out of paypal
    if (R.propEq("state", FLOW_STATE.CANCEL, payload)) return;

    onComplete(payload);
  });

  if (ccState) {
    return <CreditCard config={config} {...props} onComplete={handleCCComplete} />;
  }

  const Layout = inIframe() ? IFrame : FullPage;
  return (
    <Layout>
      <VStack spacing={5} align="stretch">
        <Header
          onCloseButtonClick={handleCancel}
          title={formatMessage({
            defaultMessage: "Add Payment Method",
            description: "Title - Header",
          })}
          showLanguage
        />
        <Box
          data-testid="addpm-button-container"
          sx={{
            "& > div": { marginBottom: "8px" },
          }}
        >
          <div>{config.addPaypal && <AddPaypalButton />}</div>
          <div>{config.addCC && <AddCCButton onClick={handleCCClick} />}</div>
        </Box>
      </VStack>
    </Layout>
  );
};
